import React from "react";
import { Card, Row, Col } from "antd";
import { useHistory } from "react-router-dom";
import {
  FileTextOutlined,
  DollarOutlined,
  ClockCircleOutlined,
  BarChartOutlined,
  PieChartOutlined,
  CarOutlined
} from "@ant-design/icons";
import AdminBreadCrumb from "components/AdminBreadCrumb";
import "./BillingReportsIndex.scss";

const BillingReportsIndex = () => {
  const history = useHistory();

  const breadCrumbs = [
    { text: "BILLING", url: "/admin/billing-dashboard" },
    { text: "REPORTS", url: "/admin/billing/reports" }
  ];

  const reports = [
    {
      key: "revenue",
      title: "SaaS vs Managed Revenue",
      subtitle: "SaaS revenue vs Delivery revenue",
      icon: <DollarOutlined />,
      path: "/admin/billing/reports/revenue",
      color: "#1890ff"
    },
    {
      key: "receivables",
      title: "Receivables",
      subtitle: "Outstanding invoices",
      icon: <FileTextOutlined />,
      path: "/admin/billing/reports/receivables",
      color: "#52c41a"
    },
    {
      key: "estimate-vs-final",
      title: "Estimate vs Final",
      subtitle: "Compare route estimates with final prices",
      icon: <BarChartOutlined />,
      path: "/admin/billing/reports/estimate-vs-final",
      color: "#fa8c16"
    },
    {
      key: "revenue-analysis",
      title: "Revenue Analysis",
      subtitle: "Analyze revenue by service, vehicle type, client, or driver",
      icon: <PieChartOutlined />,
      path: "/admin/billing/reports/revenue-analysis",
      color: "#722ed1"
    },
    {
      key: "sales",
      title: "Sales Report",
      subtitle: "View comprehensive sales analytics and revenue data",
      icon: <DollarOutlined />,
      path: "/admin/reports/sales",
      color: "#13c2c2"
    },
    {
      key: "driver-billing",
      title: "Driver Billing Report",
      subtitle: "View driver earnings by estimate and final prices",
      icon: <CarOutlined />,
      path: "/admin/billing/reports/drivers",
      color: "#eb2f96"
    }
  ];

  return (
    <div className="billing-reports-index-page admin">
      <div className="common-header">
        <AdminBreadCrumb breadCrumbs={breadCrumbs} />
      </div>

      <div className="content-wrapper">
        <h2>Billing Reports</h2>
        <p style={{ marginBottom: 24, color: "#666" }}>
          Select a report to view detailed analytics and insights.
        </p>

        <Row gutter={[24, 24]}>
          {reports.map((report) => (
            <Col xs={24} sm={12} lg={8} key={report.key}>
              <Card
                className={`report-card ${report.disabled ? "disabled" : ""}`}
                hoverable={!report.disabled}
                onClick={() => {
                  if (!report.disabled && report.path) {
                    history.push(report.path);
                  }
                }}
                style={{
                  height: "100%",
                  cursor: report.disabled ? "not-allowed" : "pointer",
                  opacity: report.disabled ? 0.6 : 1
                }}
              >
                <div className="report-card-content">
                  <div
                    className="report-icon"
                    style={{
                      fontSize: 48,
                      color: report.color,
                      marginBottom: 16
                    }}
                  >
                    {report.icon}
                  </div>
                  <h3 style={{ marginBottom: 8 }}>{report.title}</h3>
                  <p style={{ color: "#666", marginBottom: 0 }}>{report.subtitle}</p>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default BillingReportsIndex;
